import Drawable from './Drawable.js';
import Sprite from '../ui/Sprite.js';
import { imageStore } from '../images.js';

export default class OverworldDecoration extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            type: this.type,
            position: this.position,
            visible: this.visible,
        };
    }

    static deserialize(data) {
        return new OverworldDecoration({
            type: data.type,
            position: data.position,
        });
    }

    constructor({ type, position, OSM, GUI }) {
        super({ position });
        this.visible = true;
        this.position = position;
        this.width = 16;
        this.height = 16;
        this.xModifier = 0;
        this.yModifier = 0;
        this.OSM = OSM;
        this.GUI = GUI;
        this.type = type;
        switch (type) {
            case 'flowers':
                this.sprite = new Sprite({
                    position: this.position,
                    image: imageStore.get('img/flowers.png'),
                    moving: true,
                    visible: this.visible,
                    hold: 12 + Math.round(Math.random() * 4),
                    frames: { max: 5, val: Math.round(Math.random() * 5) },
                });
                this.drawAbovePlayer = true;
        }
    }

    setType(type) {
        switch (type) {
            case 'flowers':
                this.sprite = new Sprite({
                    position: this.position,
                    image: imageStore.get('img/flowers.png'),
                    moving: true,
                    visible: this.visible,
                    hold: 16,
                    frames: { max: 5, val: Math.round(Math.random() * 5) },
                });
        }
    }

    draw() {
        if (!this.visible) {
            return;
        }

        if (!this.type) {
            return;
        }
        this.sprite.position = this.effectivePosition();
        this.sprite.draw();
    }
}
